import React, { Component } from 'react'
import Icon from './Icon'

class CommentIcon extends Component {
  render () {
    return (
      <Icon {...this.props}>
        <svg
          x='0px'
          y='0px'
          viewBox='0 0 24 24'
          enableBackground='new 0 0 24 24'
        >
          <g>
            <path
              className='icon__fill'
              fill='#BFC6D1'
              d='M19.908,4.059H3.955c-1.097,0-1.994,0.897-1.994,1.994V24l3.988-3.988h13.959c1.097,0,1.994-0.897,1.994-1.994V6.053
        		C21.902,4.956,21.005,4.059,19.908,4.059z M5.949,11.038h11.965v1.995H5.949V11.038z M13.926,16.022H5.949v-1.993h7.977V16.022z
        		 M17.914,10.041H5.949V8.047h11.965V10.041z'
            />
          </g>
        </svg>
      </Icon>
    )
  }
}

export default CommentIcon
